import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';
import { Count } from '../../../models/count';
import { SchoolFile, SchoolFileCategory } from '../../../models/schoolFile';

const DEFAULT_FILTER: any = {
  limit: DEFAULT_LIMIT,
  skip: DEFAULT_SKIP
};

export function getSchoolFiles(user: AppUser, filter = DEFAULT_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter: {
        where: {
          ...filter.where
        },
        skip: filter.skip,
        limit: filter.limit,
        order: filter.order
      }
    }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/files`, config).then(response => {
    return response.data;
  });
}

export function getAllSchoolFiles(user: AppUser, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  }

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/files`, config).then(response => {
    return response.data;
  });
}

export function getSchoolFilesCount(user: AppUser, where?): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          }
        }
      }
    };
  } else {
    config = {
      headers: { usid: key }
    };
  }

  return axios.get<Count>(`${window.apiBase}/i/schools/${activeSchoolId}/files/count`, config).then(response => {
    return response.data;
  });
}

export function getSchoolFile(user: AppUser, fileId: string): Promise<SchoolFile> {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .get<SchoolFile>(`${window.apiBase}/i/schools/${activeSchoolId}/files/${fileId}`, config)
    .then(response => {
      return response.data;
    });
}

export function createSchoolFile(user: AppUser, form: any) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key }
  };

  return axios.post(`${window.apiBase}/i/schools/${activeSchoolId}/files`, form, config).then(response => {
    return response.data;
  });
}

export function updateSchoolFile(user: AppUser, filesId: string, data: any) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key }
  };

  return axios.put(`${window.apiBase}/i/schools/${activeSchoolId}/files/${filesId}`, data, config).then(response => {
    return response.data;
  });
}

export function deleteSchoolFile(user: AppUser, filesId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key }
  };

  return axios.delete(`${window.apiBase}/i/schools/${activeSchoolId}/files/${filesId}`, config).then(response => {
    return response.data;
  });
}

const documentConfig = (user: AppUser) => ({ headers: { usid: user.roleSessionKey } });

export function getSchoolFileCategories(user: AppUser): Promise<SchoolFileCategory[]> {
  return axios
    .get(`${window.apiBase}/i/schools/${user.activeSchoolId}/fileCategories`, documentConfig(user))
    .then(response => response.data);
}

export function createSchoolFileCategory(user: AppUser, data: Partial<SchoolFileCategory>): Promise<SchoolFileCategory> {
  return axios
    .post(`${window.apiBase}/i/schools/${user.activeSchoolId}/fileCategories`, data, documentConfig(user))
    .then(response => response.data);
}

export function updateSchoolFileCategory(user: AppUser, categoryId: string, data: Partial<SchoolFileCategory>): Promise<SchoolFileCategory> {
  return axios
    .put(`${window.apiBase}/i/schools/${user.activeSchoolId}/fileCategories/${categoryId}`, data, documentConfig(user))
    .then(response => response.data);
}

export function deleteSchoolFileCategory(user: AppUser, categoryId: string) {
  return axios.delete(
    `${window.apiBase}/i/schools/${user.activeSchoolId}/fileCategories/${categoryId}`,
    documentConfig(user)
  );
}
